import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@cuekards/ui/styles.css";
import "./tokens.css";
import "./web.css";
import { boot } from "./boot.js";
import { browserFacts, missingCapabilities } from "./capabilities.js";
import { CapabilityGate } from "./CapabilityGate.js";

/**
 * The page's entry point — the web's equivalent of the desktop's four renderer
 * entry points, of which this is the only one, because a tab is one surface.
 *
 * It decides which of the two things this browser gets and does nothing else. The
 * stylesheet is pulled in here for the same reason it is in the desktop's entry
 * points — which bundler stage handles an asset is the host's business — and
 * because the gate is drawn with it.
 *
 * **The gate is in front of everything, which is the whole of its value** (web
 * ticket 17, stories 2 and 3). A browser that cannot run cuekards is told which
 * capability is missing before a worker is started, before a permission is asked
 * for and before a download is offered — rather than being allowed to get as far
 * as pressing record and then being handed whichever API threw first. On a browser
 * with no `Worker` at all, `boot` is what would have thrown.
 */

const container = document.getElementById("root");
if (!container) throw new Error("cuekards: #root not found");
const root = createRoot(container);

const missing = missingCapabilities(browserFacts());
if (missing.length > 0) {
  root.render(
    <StrictMode>
      <CapabilityGate missing={missing} />
    </StrictMode>,
  );
} else {
  boot(root);
}
